import Facility from "./facility/Facility";
import Broadcast from "./broadcast/Broadcast";
import Register from "./auth/Register";
import Login from "./auth/Login";
import UpdatePassword from "./auth/UpdatePassword";
import Payment from "./auth/payment";
import { Screens } from "types/general";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import MVLogoBlue from "img/MuscoVision_logo-blue-grey.svg";

export default function Main() {
	const location = useLocation();
	const queryString = location.search;
	const urlSearchParams = new URLSearchParams(queryString);
	const theme = urlSearchParams.get("theme");
	const facilityId = urlSearchParams.get("facilityId");
	const [screen, setScreen] = useState<Screens>("facility");
	const [selectedBroadcastId, setSelectedBroadcastId] = useState<string>();

	if (theme) {
		document.documentElement.setAttribute("data-bs-theme", theme === "light" ? "light" : "dark");
	}

	const handleBroadcastSelected = (id: string) => {
		setSelectedBroadcastId(id);
		setScreen("broadcast");
	};

	const onAuthSuccess = () => {
		if (selectedBroadcastId) {
			setScreen("broadcast");
		} else {
			setScreen("facility");
		}
	};

	const renderScreen = () => {
		if (!theme || !facilityId) {
			return <ErrorPage />;
		} else {
			switch (screen) {
				case "facility":
					return <Facility facilityId={facilityId} selectBroadcast={(id) => handleBroadcastSelected(id)} />;
				case "broadcast":
					return (
						<Broadcast
							id={selectedBroadcastId!}
							setSelectedBroadcastId={(id) => setSelectedBroadcastId(id)}
							setScreen={(v) => setScreen(v)}
							facilityId={facilityId}
						/>
					);
				case "login":
					return <Login setScreen={(v) => setScreen(v)} onSuccess={onAuthSuccess} />;
				case "register":
					return <Register setScreen={(v) => setScreen(v)} onSuccess={onAuthSuccess} />;
				case "pay":
					return <Payment onSuccess={onAuthSuccess} setScreen={(v) => setScreen(v)} />;
				case "update_password":
					return <UpdatePassword />;
				default:
					return null;
			}
		}
	};

	return (
		<div>
			<div className="d-flex justify-content-center my-4">
				<button className="btn" onClick={() => setScreen("facility")}>
					<img width="162" src={MVLogoBlue} alt="MuscoVision Logo" />
				</button>
			</div>
			{renderScreen()}
		</div>
	);
}
